import { supabase } from "@common/api/authService";

export const runSelect = (query: string) => {
    return supabase.rpc("run_select_ws", { 
        p_query: query,
        p_workspace_id: window.Bustly?.workspace_id
    });
}